import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import Footer from "src/components/layout/Footer";
import Loader from "src/components/loaders/Loader";
import { PrivacyPolicyItems } from "src/types/items/PrivacyPolicy";
import { usePageNotFoundStore } from "src/store/layout/usePageNotFoundStore";

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation();

  const language = i18n.language;
  const isRTL = language === "ar";

  const { loading, setLoading } = usePageNotFoundStore();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [setLoading]);

  if (loading) {
    return <Loader />;
  }
  
  return (
  <>
    <main
      className={clsx("min-h-screen relative z-0")}
    >
      {/* Hero Section */}

      <div className="max-w-4xl mx-auto text-center mt-20">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            <span className="text-primary"> 
            {t("PrivacyPolicy")}
             </span>
          </h1>
        </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div
          className={clsx(
            "bg-white dark:bg-dark-200 rounded-3xl p-8 shadow-xl",
            { "text-right": isRTL }
          )}
        >
          {PrivacyPolicyItems.map((section, index) => {
            // قم بتعيين الوصف الحالي لمتغير لضمان تضييق النوع بشكل صحيح
            const currentDescription = isRTL ? section.description?.ar : section.description?.en;

            return (
              <div key={index} className="space-y-6">
                <h3 className="text-xl font-semibold mb-2">
                  {isRTL ? section.title.ar : section.title.en}
                </h3>
                {currentDescription && (
                  <p className="text-gray-600 dark:text-gray-400 pb-10 whitespace-pre-wrap">
                 
                    {Array.isArray(currentDescription)
                      ? currentDescription.map((part, partIndex) => (
                          <span
                            key={partIndex}
                            className={clsx({
                              "font-bold": part.type === "bold",
                            })}
                          >
                            {part.value}
                          </span>
                        ))
                      : currentDescription}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </main>
    <Footer />
  </>
  );
}